import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path d="M13 10H11V14H13V10Z" xmlns="http://www.w3.org/2000/svg" />,
  "LineSx"
);
